import {useTranslation} from '@/translations/i18n'
import {InputSelectReportType} from '@/features/medical-reports/components/input-select-report-type/InputSelectReportType'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {MedicalRecordSearchParams} from '@/features/medical-records/types'
import {StyledMedicalRecordReportTypeFilterWrapper} from './style'
import {useGetMedicalReportType} from '@/features/medical-reports/queries/useGetMedicalReportType'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const MedicalRecordReportTypeFilter = () => {
    const {t} = useTranslation()

    const {
        setSearchParams,
        searchParams: {medicalRecordReportTypeId}
    } = useParsedSearchParams(MedicalRecordSearchParams)

    const {data: medicalReportType, isLoading: isLoadingMedicalReportType} = useGetMedicalReportType({
        urlParams: {id: medicalRecordReportTypeId ?? ''},
        options: {
            enabled: !!medicalRecordReportTypeId
        }
    })

    if (isLoadingMedicalReportType) {
        return <Skeleton width={100} height={28} />
    }

    return (
        <StyledMedicalRecordReportTypeFilterWrapper>
            <InputSelectReportType
                value={medicalReportType}
                placeholder={t('medical_records:report_type')}
                specializationId=""
                onClear={() => {
                    setSearchParams({medicalRecordReportTypeId: undefined})
                }}
                onChange={medicalReportType => {
                    if (medicalReportType) {
                        setSearchParams({medicalRecordReportTypeId: medicalReportType.id})
                    } else {
                        setSearchParams({medicalRecordReportTypeId: undefined})
                    }
                }}
            />
        </StyledMedicalRecordReportTypeFilterWrapper>
    )
}
